// src/contexts/FilterContext.jsx
// Context for sharing Tools/Documents/Messages filter state
// between AppShell header and page components

import React, { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

export function FilterProvider({ children }) {
  const [activeFilter, setActiveFilter] = useState('Tools'); // Default to Tools
  
  return (
    <FilterContext.Provider value={{ activeFilter, setActiveFilter }}>
      {children}
    </FilterContext.Provider>
  );
}

export function useFilter() {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilter must be used within a FilterProvider');
  }
  return context;
}